module.exports = __webpack_public_path__ + "img/bjasd.758ecce6.png";